<template>
  <nav class="bg-white border-b border-gray-200">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex justify-between h-16">
        <div class="flex">
          <div class="flex-shrink-0 flex items-center">
            <!-- Use full logo when we have room, just mark when we don't -->
            <router-link
              to="/"
              class="transition duration-500 ease-in-out"
              exact-active-class="text-blue-400"
            >
              &lt;&sol;&gt; precommit
            </router-link>
            <router-link
              to="/"
              class="font-mono text-xs relative -ml-8 mt-8 text-gray-500"
              >beta</router-link
            >
            <!-- TODO - UPDATE IMAGES -->
            <!-- <img
              class="block lg:hidden h-8 w-auto"
              src="/img/logos/workflow-mark-on-white.svg"
              alt="Workflow logo"
            />
            <img
              class="hidden lg:block h-8 w-auto"
              src="/img/logos/workflow-logo-on-white.svg"
              alt="Workflow logo"
            /> -->
          </div>
          <div v-if="signedIn" class="hidden sm:-my-px sm:ml-6 sm:flex">
            <!-- TODO - DECIDE ON WHAT WE WANT THE FOCUS STATE TO LOOK LIKE -->
            <router-link
              v-for="page in pages"
              :key="page.title"
              :to="page.route"
              class="inline-flex items-center mx-1 px-2 pt-1 border-b-4 border-transparent text-sm font-normal leading-5 text-gray-900 focus:outline-none focus:border-blue-400 transition duration-300 ease-in-out"
              exact-active-class="border-blue-400"
            >
              {{ page.title }}
            </router-link>

            <!-- <a
              href="#"
              class="ml-8 inline-flex items-center px-1 pt-1 border-b-2 border-transparent text-sm font-medium leading-5 text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300 transition duration-150 ease-in-out"
            >
              Team
            </a> -->
          </div>
        </div>
        <div v-if="signedIn" class="hidden sm:ml-6 sm:flex sm:items-center">
          <div class="ml-3 relative">
            <div>
              <button
                @click="open = !open"
                class="flex text-sm border-2 border-transparent rounded-full focus:outline-none focus:border-gray-300 transition duration-150 ease-in-out"
                id="user-menu"
              >
                <avatar :name="name" />
                <!-- TODO - UPDATE IMAGE TO BE BASED ON LOGGED IN USER -->
                <!-- <img
                  class="h-8 w-8 rounded-full"
                  src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                  alt=""
                /> -->
              </button>
            </div>
            <div
              v-if="open"
              class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg"
            >
              <!-- TODO - UPDATE TO ROUTERLINKS AND ACTIVECLASS HIGHLIGHTING -->
              <div
                class="py-1 rounded-md bg-white shadow-xs"
                v-on-clickaway="() => (open = false)"
              >
                <router-link
                  v-for="link in menuLinks"
                  :key="link.routeName"
                  :to="link.route"
                  class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"
                >
                  {{ link.title }}
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <!-- Small Formfactor -->
        <div class="-mr-2 flex items-center sm:hidden">
          <button
            @click="open = !open"
            class="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-500 transition duration-150 ease-in-out"
          >
            <svg
              class="h-6 w-6"
              stroke="currentColor"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                :class="{ hidden: open, 'inline-flex': !open }"
                class="inline-flex"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
              <path
                :class="{ hidden: !open, 'inline-flex': open }"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
    <div
      v-if="signedIn"
      :class="{ block: open, hidden: !open }"
      class="sm:hidden"
    >
      <div v-if="pages.length" class="pt-2 pb-3">
        <!-- TODO - SYNC WITH DESKTOP COLORS -->
        <router-link
          v-for="page in pages"
          :key="page.route"
          :to="page.route"
          class="block pl-3 pr-4 py-2 border-l-4 border-transparent text-base font-medium bg-blue-50 focus:outline-none focus:text-blue-800 focus:bg-blue-100 focus:border-indigo-700 transition duration-150 ease-in-out"
          exact-active-class="border-blue-400 text-blue-400"
        >
          {{ page.title }}
        </router-link>
        <!-- <a
          href="#"
          class="mt-1 block pl-3 pr-4 py-2 border-l-4 border-transparent text-base font-medium text-gray-600 hover:text-gray-800 hover:bg-gray-50 hover:border-gray-300 focus:outline-none focus:text-gray-800 focus:bg-gray-50 focus:border-gray-300 transition duration-150 ease-in-out"
          >Team</a
        > -->
      </div>
      <div class="pt-4 pb-3 border-t border-gray-200">
        <div class="flex items-center justify-center px-4">
          <!-- TODO - PIVOT OFF IF THEY ARE LOGGED IN OR NOT -->
          <div class="ml-3">
            <div class="text-base font-medium leading-6 text-gray-800">
              {{ name }}
            </div>
            <div class="text-sm font-medium leading-5 text-gray-500">
              {{ email }}
            </div>
          </div>
        </div>
        <div
          class="mt-3"
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="user-menu"
        >
          <!-- TODO - ACTUAL ROUTER LINKS PLEASE -->
          <router-link
            v-for="link in menuLinks"
            :key="link.routeName"
            :to="link.route"
            class="mt-1 block px-4 py-2 text-base font-medium text-gray-500 hover:text-gray-800 hover:bg-gray-100 focus:outline-none focus:text-gray-800 focus:bg-gray-100 transition duration-150 ease-in-out"
            role="menuitem"
          >
            {{ link.title }}
          </router-link>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { mixin as clickaway } from "vue-clickaway";

import Avatar from "@/components/Avatar";

export default {
  name: "Navigation",
  mixins: [clickaway],
  components: {
    Avatar,
  },
  data() {
    return {
      // pages: ["Progress", "Goals", "Mentors"],
      pages: [
        {
          title: "home",
          route: "/",
        },
        {
          title: "advisors",
          route: "/advisors",
        },
        {
          title: "updates",
          route: "/updates",
        },
      ],
      menuLinks: [
        { title: "Profile", route: "/profile" },
        // { title: "Settings", routeName: "" },
        { title: "Sign Out", route: "logout" },
      ],
      open: false,
    };
  },
  computed: {
    signedIn() {
      return this.$store.state.auth.signedIn;
    },
    name() {
      return this.$store.state.auth.user.displayName || "";
    },
    email() {
      return this.$store.state.auth.user.email;
    },
  },
  watch: {
    $route() {
      this.open = false;
    },
  },
};
</script>
